import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StandingsService {

  constructor(private http: HttpClient) { }

  show(search_params: any): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/api/v1/standings/show?standings_id=${search_params['standings_id']}&team_id=${search_params['team_id']}`);
  }

  teamsByDivision(selectedDivisionId: any): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/api/v1/standings?division_id=${selectedDivisionId}`)
  }

  createOrUpdate(params: any): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/api/v1/standings`, {
      team_id: params.team_id,
      group_id: params.group_id,
      game_wins: params.game_wins,
      game_losses: params.game_losses,
      map_wins: params.map_wins,
      map_losses: params.map_losses
    });
  }
}
